import { m } from "framer-motion"
import { Icon } from "@iconify/react"

import { Box, alpha, Stack, Button, useTheme, Typography } from "@mui/material"

import Image from "src/components/image"
import Iconify from "src/components/iconify";

import { useMyInterestInvite } from "./my-interest-invite.hook";

interface MyInterestInviteProps {
    startQuiz: any,
    handleCloseDialog: () => void
}

export default function MyInterestInvite({ startQuiz, handleCloseDialog }: MyInterestInviteProps) {

    const {
        currentImage,
        items,
        itemVariants,
        imageVariants,
        skipAnimation,
        handleClickButton
    } = useMyInterestInvite(startQuiz)

    const theme = useTheme()

    return (
        <>

            <Stack bgcolor='primary.darker' color='white' height='calc(100vh - 72px)' alignItems='center'>
                <Stack pt={12} width='100%' px={12}>
                    <Stack alignSelf='flex-end'>
                        <Button
                            sx={{
                                maxWidth: 'fit-content',
                                borderRadius: 10,
                                px: 0,
                                py: "0px !important",
                                flex: 0
                            }}
                            onClick={handleCloseDialog}
                            disableRipple
                        >
                            <Stack direction='row' alignItems='center' spacing={1}>
                                <Typography variant='inputXS700' fontWeight='normal'>
                                    Fechar
                                </Typography>
                                <Iconify icon='ri:close-fill' />
                            </Stack>
                        </Button>
                    </Stack>
                    <Box height={32} />
                    <Stack >
                        <Typography variant='h2'>
                            Personalize a sua experiência
                        </Typography>
                    </Stack>
                </Stack>
                <Box maxHeight='90vh' overflow='auto' px={12} pb={12}>
                    <Stack minHeight='45vh' maxHeight='fit-content'>
                        <m.div initial="hidden" animate="visible" variants={imageVariants} key={currentImage}>
                            <Image src={currentImage} />
                        </m.div>
                    </Stack>

                    <Stack spacing={10} flex={1}>
                        {items.map((item, index) => (
                            <m.div
                                key={`${index}-${skipAnimation.value}`}
                                custom={index}
                                initial={skipAnimation.value ? 'visible' : "hidden"}
                                animate="visible"
                                variants={itemVariants}
                            >
                                <Stack direction="row" spacing={8} alignItems="center">
                                    <Icon
                                        icon={item.icon}
                                        width="24"
                                        height="24"
                                        color={alpha(theme.palette.common.white, 0.6)} />
                                    <Typography variant="paragraphM500" color={theme.palette.common.white}>
                                        {item.text}
                                    </Typography>
                                </Stack>
                            </m.div>
                        ))}
                    </Stack>
                </Box>
            </Stack>
            <Button
                sx={{
                    py: 18,
                    bgcolor: skipAnimation.value ? `${theme.palette.greenBrand[0]} !important` : 'primary.darker',
                    alignItems: 'center',
                    color: skipAnimation.value ? 'primary.darker' : 'yellowBrand.0',
                    gap: 4
                }}
                onClick={handleClickButton}
            >
                {skipAnimation.value ? 'Começar' : 'Pular'}
                {!skipAnimation.value &&
                    < Iconify icon='ri:arrow-right-double-fill' />
                }
            </Button>
        </>
    )
}